import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const filterS2DataUploadSchema = z.object({
  file_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  provider_config_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export const ConfigSchema = z.object({
  id: z.number(),
  code: z.string(),
  file_pattern: z.string().optional(),
  client: z.string().optional(),
  mime_type: z.string().optional(),
  template_file_id: z.number().optional(),
  template_file_name: z.string().optional(),
});

export const UploadSchema = z.object({
  config_name: z.string().min(1),
  files: z.array(z.instanceof(File)).nonempty(),
});

export type UploadSchemaType = z.infer<typeof UploadSchema>;
export type ConfigSchemaType = z.infer<typeof ConfigSchema>;

export type FilterS2DataUploadSchema = z.infer<typeof filterS2DataUploadSchema>;

const client = "s2";

export function S2DataUploadFilter() {
  const { t } = useTranslation();
  const fields: Field[] = [
    {
      name: "file_name_contains",
      label: t("data_upload.fields.file_name"),
      type: "asyncAutocomplete",
      base_url: "s2/s2_data_upload",
      column_name: "file_file_name",
    },
    {
      name: "provider_config_name_contains",
      label: t("data_upload.fields.configuration"),
      type: "asyncAutocomplete",
      base_url: "s2/s2_data_upload",
      column_name: "provider_config_name",
    },
    {
      name: "created_at",
      type: "dateRange",
      label: t("data_upload.fields.created_at"),
      from: { name: "created_at_from" },
      to: { name: "created_at_to" },
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      client={client}
      schema={filterS2DataUploadSchema}
      tableName="s2_data_upload"
      fields={fields}
    />
  );
}
